<template>
  <el-table
    :data="questionTypeData"
    border
    show-summary
    :summary-method="getSummaries"
    size="small"
    class="selfTable"
    :header-row-style="{ color: '#51627D', fontWeight: 400 }"
  >
    <el-table-column prop="paramValue" label="试题类型" align="center">
    </el-table-column>
    <el-table-column v-if="paperType === '1'" label="题库总数" align="center">
      <template slot-scope="scope">
        {{questionNumOrigin[scope.$index]}}
      </template>
    </el-table-column>
    <el-table-column label="出题数量" align="center">
      <template slot-scope="scope">
        <span v-if="paperType === '0'">{{ questionNum[scope.$index] }}</span>
        <el-input
          v-else-if="paperType === '1'"
          size="small"
          placeholder="请输入出题数量"
          v-model="questionNum[scope.$index]"
          @blur="
            e => {
              changeTotalNum(e, scope.$index);
            }
          "
          :disabled="isFromDetail"
        />
        <span v-else>--</span>
      </template>
    </el-table-column>
    <el-table-column label="每题分值" align="center">
      <template slot-scope="scope">
        <el-input
          size="small"
          placeholder="请输入分值"
          v-model="questionScore[scope.$index]"
          @blur="
            e => {
              changeTotal(e, scope.$index);
            }
          "
          :disabled="isFromDetail"
        />
      </template>
    </el-table-column>
    <el-table-column label="合计" align="center">
      <template slot-scope="scope">
        <span>{{ totalScore[scope.$index] }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    questionTypeData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    questionList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    paperType: {
      type: String,
      default: ""
    },
    isFromDetail: {
      type:  Boolean,
      default: false
    }
  },
  watch: {
    questionList(val) {
      // if (this.paperType === "0") {
        let singleTests = [];
        let mutipleTest = [];
        let judgeTest = [];
        val.forEach(ele => {
          if (ele.examQuestionType == 0) {
            singleTests.push(ele);
          } else if (ele.examQuestionType == 1) {
            mutipleTest.push(ele);
          } else if (ele.examQuestionType == 2) {
            judgeTest.push(ele);
          }
        });
        if (this.paperType === "0") {
          this.questionNum.splice(
            0,
            3,
            singleTests.length,
            mutipleTest.length,
            judgeTest.length
          );
          // this.questionNum.forEach((ele, index) => {
          //   this.$set(
          //     this.totalScore,
          //     index,
          //     (this.questionScore[index] * ele).toFixed(1)
          //   );
          // });
        }
        this.questionNumOrigin.splice(
          0,
          3,
          singleTests.length,
          mutipleTest.length,
          judgeTest.length
        );
        this.questionNum.forEach((ele, index) => {
          this.$set(
            this.totalScore,
            index,
            (this.questionScore[index] * ele).toFixed(1)
          );
        });
      //}
    }
  },
  data() {
    return {
      questionScore: ["", "", ""],
      questionNum: [0, 0, 0],
      questionNumOrigin: [0, 0, 0],
      totalScore: [
        Number(0).toFixed(1),
        Number(0).toFixed(1),
        Number(0).toFixed(1),
      ]
    };
  },
  computed: {
    examTotalTest() {
      return this.questionNum
        .reduce((prev, cur) => parseFloat(prev) + parseFloat(cur))
        .toFixed(1);
    },
    examTotalScore() {
      return this.totalScore
        .reduce((prev, cur) => parseFloat(prev) + parseFloat(cur))
        .toFixed(1);
    }
  },
  methods: {
    // 自定义合计栏显示内容
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
        }
        if (this.paperType === "0") {
          if (index === 1) {
            sums[index] = this.questionNum.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return Number(prev) + Number(curr);
              } else {
                if (isNaN(Number(prev))) {
                  return 0;
                }
                return prev;
              }
            }, 0);
          }
          if (index === 2) {
            sums[index] = "--";
          }
          if (index === 3) {
            sums[index] = this.totalScore
            .reduce((prev, curr) => {
              return Number(prev) + Number(curr);
            }, 0)
            .toFixed(1);
          }
        }
        if (this.paperType !== "0") {
          if (index === 1) {
            sums[index] = this.questionNumOrigin.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return Number(prev) + Number(curr);
              } else {
                if (isNaN(Number(prev))) {
                  return 0;
                }
                return prev;
              }
            }, 0);
          }
          if (index === 2) {
            sums[index] = this.questionNum.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return Number(prev) + Number(curr);
              } else {
                if (isNaN(Number(prev))) {
                  return 0;
                }
                return prev;
              }
            }, 0);
          }
          if (index === 3) {
            sums[index] = "--";
          }
          if (index === 4) {
            sums[index] = this.totalScore
            .reduce((prev, curr) => {
              return Number(prev) + Number(curr);
            }, 0)
            .toFixed(1);
          }
        }
      });
      return sums;
    },
    changeTotalNum(e, index) {
      if (e.target.value === "") {
        this.$set(this.totalScore, index, Number(0).toFixed(1));
        return;
      }
      const val = e.target.value;
      if (val.match(/(^[1-9]\d*$)/) && !val.match(/\.$/)) {
        this.$set(
          this.totalScore,
          index,
          (Number(this.questionScore[index]) * Number(e.target.value)).toFixed(
            1
          )
        );
      } else {
        e.target.value = "";
        // 重置总分
        this.$set(this.questionNum, index, "");
        this.$message({
          message: "请输入正整数",
          type: "error"
        });
      }
    },
    // 用户输入分值后
    changeTotal(e, index) {
      if (e.target.value === "") {
        this.$set(this.totalScore, index, Number(0).toFixed(1));
        return;
      }
      const val = e.target.value;
      let reg = /^(((\d{1,2})[.]((\d{0,1})?))|(?:0|[1-9][0-9]?)|100[.]0?|100)$/;
      if (val.match(reg) && !val.match(/\.$/)) {
        this.$set(
          this.totalScore,
          index,
          (Number(this.questionNum[index]) * Number(e.target.value)).toFixed(1)
        );
      } else {
        e.target.value = "";
        // 重置总分
        this.$set(this.totalScore, index, Number(0).toFixed(1));
        this.$message({
          message: "请输入0-100之间的数字，最多1位小数",
          type: "error"
        });
      }
    },
    // 暴露一个重置分数的方法供外界使用
    reset() {
      this.questionScore = ["", "", ""];
      this.questionNum = [0, 0, 0];
      this.totalScore = [
        Number(0).toFixed(1),
        Number(0).toFixed(1),
        Number(0).toFixed(1)
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.selfTable {
  /deep/ .el-table th > .cell {
    color: #51627d;
    font-weight: 400;
  }
}
</style>
